import type { PublicSiteLocaleOverride } from '../publicSiteTypes'

export const ptPublicSiteOverride = {
  content: {
    brand: {
      tagline: 'Planos vivos, não travados',
    },
    routes: [
      { label: 'Visão geral', title: 'The Timelining App', description: 'Um workspace visual com economia de créditos, revisão de IA e loop RPG que mantém planos vivos.' },
      { label: 'Soluções', title: 'Soluções', description: 'Fluxos reais: lançamentos, agências, criadores, estudantes, operações de campo e cohorts.' },
      { label: 'Guia', title: 'Guia', description: 'O passo a passo completo: do workspace vazio ao plano entregue, com cada superfície, papel e cerimônia.' },
      { label: 'Recursos', title: 'Recursos', description: 'Padrões prontos para copiar, biblioteca de prompts de IA, templates de checklist e cadências.' },
      { label: 'Preços', title: 'Preços', description: 'Preço por economia de créditos. Pague pelo que usa, não por assentos.' },
      { label: 'Download', title: 'Download', description: 'Instale os apps Android Member e Helper pela página pública de download.' },
      { label: 'Sobre', title: 'Sobre', description: 'Por que este app existe, o que defende, o que já saiu e o que vem depois.' },
      { label: 'FAQ', title: 'FAQ', description: '25 perguntas sobre setup, IA, gamificação, equipes e dados.' },
      { label: 'Contato', title: 'Contato', description: 'Fale conosco sobre pilotos, suporte, feedback, demos e imprensa.' },
    ],
    hero: {
      eyebrow: 'Planejamento visual · créditos · revisão de IA',
      headline: 'Planos vivos, não travados',
      accent: 'vivos',
      primaryCtaSignedOut: 'Abrir o app',
      primaryCtaSignedIn: 'Abrir meu workspace',
      secondaryCta: 'Ler o guia',
      consoleNoteSignedOut: 'O login abre a experiência privada do app.',
      consoleNoteSignedIn: 'Você está conectado. Continue do workspace atual.',
    },
    ctaBand: {
      eyebrow: 'Pronto?',
      title: 'Abra a Console. Ou pegue o app.',
      primary: 'Abrir Console',
      secondary: 'Obter APKs',
    },
  },
  chrome: {
    nav: {
      ariaLabel: 'Navegação pública',
      brandHomeSuffix: 'início',
      contact: 'Contato',
      getStarted: 'Começar',
      languageLabel: 'Idioma',
      languageAriaLabel: 'Idioma do site',
    },
    common: {
      openWorkspace: 'Abrir meu workspace',
      openConsole: 'Abrir Console',
      featureColumnHeader: 'Recurso',
      capabilityColumnHeader: 'Capacidade',
    },
    download: {
      eyebrow: 'Obter Timelining',
      title: 'Instale os apps Android.',
      downloadApk: 'Baixar APK',
      copyLink: 'Copiar link',
      share: 'Compartilhar',
    },
  },
} satisfies PublicSiteLocaleOverride
